// custom cells for the table
import { DemoUser } from "../../Type";
import Count from "./Cells/Count";
import Email from "./Cells/Email";
import LastConnection from "./Cells/LastConnection";

type Col = {
	id: string;
	Cell: (demo: DemoUser) => JSX.Element | null;
	align?: "center" | "left";
};

const cols: Col[] = [
	{
		id: "email",
		Cell: Email,
		align: "left"
	},
	{
		id: "demoCount",
		Cell: Count,
		align: "left"
	},
	{
		id: "lastConnection",
		Cell: LastConnection,
		align: "left"
	}
];

export default cols;
